import * as React from "react";
import { connect } from "react-redux";
import { withLastLocation } from "react-router-last-location";
import { compose } from "recompose";
import queryString from "query-string";
import InfiniteScroll from "react-infinite-scroll-component";
import { withStyles, createStyles } from "@material-ui/core/styles";
import { Grid, CircularProgress } from "@material-ui/core";
import AppBarV2 from "Components/Application/AppBarV2";
import LayeredCard from "Components/Application/Components/Evaluate/Components/Common/LayeredCard";
import ProductTypeFilter from "Components/Common/Filters/ProductTypeFilter";
// redux
import { updateDrawerStyle } from "redux/drawer/action";
import { showAddVendorDialog } from "redux/vendor/vendorCatalog/action";
import { showSnackBar } from "redux/snackbar/action";

import { matchPath } from "react-router-dom";
import { storeSearchString } from "redux/applications/action";
import { fetchVendorServiceCatalog } from "redux/vendor/vendorServiceCatalog/action";

const connectedProps = (state) => ({
  userType: state.authUser.user?.Role,
  orgUser: state.orgUser,
  orgName: state.authUser.user?.Organization?.Name,
  searchString: state.applications.searchString,
  searchType: state.applications.searchType,
  fetchVendorServiceCatalogProgress: state.vendorServiceCatalog.fetchVendorServiceCatalogProgress,
  fetchVendorServiceCatalogError: state.vendorServiceCatalog.fetchVendorServiceCatalogError,
  VendorServiceCatalog: state.vendorServiceCatalog.VendorServiceCatalog,
});

const connectionActions = {
  showAddVendorDialog: showAddVendorDialog,
  updateDrawerStyle: updateDrawerStyle,
  showSnackBar: showSnackBar,
  fetchVendorServiceCatalog: fetchVendorServiceCatalog,
  storeSearchString: storeSearchString,
};

var connector = connect(connectedProps, connectionActions);

const styles = (theme) =>
  createStyles({
    productCount: {
      color: "#282D30",
      fontSize: 14,
      marginTop: 10,
      paddingLeft: 20,
    },
    productContainer: {
      maxHeight: "calc(100vh - 250px)",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      minHeight: "calc(100vh - 250px)",
      padding: theme.spacing(4, 0),
    },
    productCounts: {
      fontSize: "12px",
      marginLeft: "auto",
      fontWeight: "600",
      color: "#4a87f8",
    },
    productMain: {
      padding: "2rem",
    }
  });

class Services extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headerSectionWidth: null,
      selectedProduct: null,
      isProduct: false,
      queryParams: queryString.parse(this.props.location.search),
      filters: {
        sortby: "relevance",
        order: "",
      },
      isCreateGroup: false,
      selectedGroupProduct: [],
      selectedState: [],
      searchObj: {
        text: "",
        page: 0,
        page_size: 500,
        filters: { is_org: "1" },
      },
      lastLocation: this.props.lastLocation,
      productType: "SERVICE",
      filterServiceId: "",
      searchRestored: false,
    };
  }

  componentDidMount() {
    const urlPrams = new URLSearchParams(this.props.location.search);
    setTimeout(() => {
      this.props.updateDrawerStyle(false, true);
    }, 100);

    if (urlPrams.get("s") !== null) {
      this.setState({ searchObj: { ...this.state.searchObj, text: urlPrams.get("s") }},
        () => this.fetchData()
      );
    } else {
      this.fetchData();
    } 
  }

  componentDidUpdate(prevProps, prevState) {
    const { lastLocation } = this.state;
    var pathName = lastLocation?.pathname;
    var isMatched = false;
    if (pathName !== undefined) {
      if (
        matchPath(pathName, {
          path: "/app/products/org-product-details/:id",
          exact: true,
          strict: false,
        })
      ) {
        isMatched = true;
      }
    }

    if (isMatched && pathName && this.props.searchString !== "" && this.state.searchRestored === false) {
      this.setState(
        {
          searchObj: { ...this.state.searchObj, field_setname: this.props.searchType, text: prevProps.searchString },
          searchRestored: true,
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  fetchData() {
    const { searchObj } = this.state;
    let queryParams = {
      query: searchObj.text,
      page_size: searchObj.page_size,
      page: searchObj.page,
      filters: searchObj.filters || {},
    };
    queryParams.filters.states = this.state.selectedState;

    this.props.fetchVendorServiceCatalog({ ...queryParams, filters: { ...queryParams.filters, is_org: "1" } });
  }

  handleRedirect = (type) => {
    if (type === "VENDOR") {
      this.props.history.push(`/app/external/vendors`);
    } else if (type === "SOFTWARE") {
      this.props.history.push(`/app/external/products`);
    } else if (type === "SERVICE") {
      this.props.history.push(`/app/external/services`);
    }
  };
  
  render() {
    const { classes, VendorServiceCatalog, fetchVendorServiceCatalogProgress } = this.props;   
    const { searchObj } = this.state;

    return (
      <div className={classes.container}>
        <AppBarV2 title={"Services"} withBack={false} dropdown={true} />
        <div className={classes.productMain}>
            <ProductTypeFilter
              type={this.state.productType}
              hideHardware
              onChange={(type) => {
                this.handleRedirect(type);
              }}
            />
            <Grid
              container
              justifyContent="space-between"
              className={classes.productSectionNew}
            >
              <Grid item>
                <p className={classes.productCount}>{VendorServiceCatalog?.total} Services found</p>
              </Grid>
            </Grid>
            <div className={classes.productContainer} id="productContainer">
              <InfiniteScroll
                scrollableTarget="productContainer"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  marginRight: 20,
                  paddingLeft: 20,
                }}
                dataLength={VendorServiceCatalog?.items?.length || 0}
                next={() => {
                  this.setState({ searchObj: { ...searchObj, page: searchObj.page + 1 } }, () => {
                    this.fetchData();
                  });
                }}
                hasMore={VendorServiceCatalog?.total > VendorServiceCatalog?.items?.length}
              >
                <Grid container spacing={3} style={{ marginBottom: 10 }}>
                  {VendorServiceCatalog?.items?.map((service, index) => (
                    <Grid item lg={2} md={3} sm={4} xs={6} key={index}>
                      <LayeredCard
                        title={this.state.filterServiceId === "" ? service.service_name : service.vendor_name}
                        subTitle={this.state.filterServiceId === "" ? "By " + service.vendor_name : ""}
                        description={service.description || ""}
                        image={service.logo || ""}
                        cardType={"vendorservice"}
                        onClick={() => {
                          this.props.history.push("/app/vendors/org-service-details/" + service.org_vendorservice_id);
                        }}
                        numLayer={0}
                        isExisting={true}
                        id={parseInt(service.org_service_id)}
                        org_vendorservice_id={service.org_vendorservice_id}
                        uniqueId={service.org_service_id + "_" + index}
                        type={"service"}
                      />
                    </Grid>
                  ))}
                </Grid>
                {fetchVendorServiceCatalogProgress && (
                  <Grid container justify="center" style={{ marginTop: 30 }}>
                    <CircularProgress />
                  </Grid>
                )}
              </InfiniteScroll>
            </div>
        </div>
      </div>
    );
  }
}

export default connector(compose(withStyles(styles), withLastLocation)(Services));
